import React from 'react';
import { PingdomContent } from './PingdomContent';
import { LogglyContent } from './LogglyContent';
import { AppOpticsContent } from './AppOpticsContent';
import { PapertrailContent } from './PapertrailContent';
import { DefaultContent } from './DefaultContent';
import Grid from '../../../../components/Grid/Grid';
import Image from '../../../../components/Image/Image';
import { PRODUCT_STATUS } from '../AppSwitcher/productsStatus';
export var SUBSCRIPTION_TYPE = {
  TRIAL: 'trial',
  FREE: 'free'
};
export var ActivationContent = function ActivationContent(props) {
  var productStatus = props.productStatus;
  var ContentComponent;
  var product = props.product;

  switch (props.product) {
    case 'appoptics':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/React.createElement(AppOpticsContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'loggly':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/React.createElement(LogglyContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'papertrail':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/React.createElement(PapertrailContent, {
          productStatus: productStatus
        });
      };

      break;

    case 'pingdom':
      ContentComponent = function ContentComponent() {
        return /*#__PURE__*/React.createElement(PingdomContent, {
          productStatus: productStatus
        });
      };

      break;

    default:
      product = 'default';
      ContentComponent = DefaultContent;
      break;
  }

  return /*#__PURE__*/React.createElement(Grid, {
    centered: true,
    "data-qa-content": product,
    "data-qa": "activation-content",
    className: "activation-content"
  }, /*#__PURE__*/React.createElement(ContentComponent, null));
};
export var ProductLogo = function ProductLogo(_ref) {
  var logo = _ref.logo;
  return /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Image, {
    src: logo,
    className: "logo"
  }));
};
export var ProductDescription = function ProductDescription(_ref2) {
  var title = _ref2.title,
      content = _ref2.content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid.Row, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, title)), /*#__PURE__*/React.createElement(Grid.Row, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, content)));
};
export var ProductSection = function ProductSection(_ref3) {
  var image = _ref3.image,
      title = _ref3.title,
      content = _ref3.content;
  return /*#__PURE__*/React.createElement(Grid.Column, {
    computer: 5,
    mobile: 16,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    className: "section-image"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "section-content"
  }, content));
};
export var Subscription = function Subscription(_ref4) {
  var productName = _ref4.productName,
      productStatus = _ref4.productStatus,
      type = _ref4.type;

  if (productStatus === PRODUCT_STATUS.CAN_ACTIVATE) {
    return /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement("div", {
      className: "subscription",
      "data-qa": "subscription"
    }, /*#__PURE__*/React.createElement(SubscriptionIntroductionText, {
      productName: productName,
      type: type
    }), /*#__PURE__*/React.createElement(SubscriptionMainText, {
      type: type
    }), /*#__PURE__*/React.createElement("br", null), "You will not be charged unless you choose to continue with a paid account."));
  }

  return null;
};

var SubscriptionIntroductionText = function SubscriptionIntroductionText(_ref5) {
  var productName = _ref5.productName,
      type = _ref5.type;
  var trialDays = productName === 'loggly' ? 30 : 14;
  if (type === SUBSCRIPTION_TYPE.TRIAL) return /*#__PURE__*/React.createElement("strong", null, "Try for ", trialDays, " days! ");
  if (type === SUBSCRIPTION_TYPE.FREE) return /*#__PURE__*/React.createElement("strong", null, "Try for Free! ");
  return null;
};

var SubscriptionMainText = function SubscriptionMainText(_ref6) {
  var type = _ref6.type;
  if (type === SUBSCRIPTION_TYPE.TRIAL) return 'During the trial you can try all features, change plan or cancel at any time.';
  if (type === SUBSCRIPTION_TYPE.FREE) return 'You can try all features, change plan or cancel at any time.';
  return null;
};